import { useFela } from 'react-fela';

import { RemoveSecretModal } from '../../RemoveSecretModal';
import { SecretHeader } from '../../SecretHeader';
import { UpdateSecretForm } from '../../UpdateSecretForm';
import { HeaderButtons } from './HeaderButtons';
import * as felaRules from './UpdateSecret.rules';

export const UpdateSecret = () => {
    const { css } = useFela();

    return (
        <div className={css(felaRules.pageContainer)}>
            <SecretHeader showBackButton={false}>
                <HeaderButtons />
            </SecretHeader>
            <main className={css(felaRules.contentContainer)}>
                <UpdateSecretForm />
                <RemoveSecretModal />
            </main>
        </div>
    );
};
